import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // StrictMode intentionally double-mounts components in dev, which breaks
  // react-leaflet's MapContainer ("Map container is already initialized").
  // Disabled so the Dispatch route map renders in the preview environment.
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
